import reducer, { actions, saga } from "./ducks";

export default { reducer, actions, saga };
